module.exports = __webpack_public_path__ + "img/nodata.ae9e865b.svg";